<template>
    <div class="available-students-per-group">
        <h4 class="group-name">{{ data.name }}</h4>

        <b-form-checkbox class="apprentice-checkbox student-checkbox"
                         v-for="student in filteredStudents"
                         :key="student.id"
                         :value="student.id"
                         @change="update(student, $event)"
                         v-model="checkedStudents">
            {{ student.full_name }}
        </b-form-checkbox>

    </div>
</template>
<script>
export default {
    name: 'design-2021-student-tree-view-component',
    props: ['data', 'indent', 'searchIn'],
    data() {
        return {
            checkedStudents: []
        }
    },
    computed: {
        filteredStudents() {
            if (this.data.students && this.data.students.length) {
                return this.data.students.filter(student => {
                    return student.full_name.toLowerCase().includes(this.searchIn.toLowerCase());
                })
            } else {
                return [];
            }
        }
    },
    methods: {
        update(student, event) {
            if (event.some(student0 => student0.id !== student.id)) {
                this.selectUser(student)
            } else {
                this.removeUser(student)
            }
        },

        selectUser(student) {
            this.$emit('selectUser', student);
        },
        removeUser(student) {
            this.$emit('removeUser', student);
        }
    },
}
</script>

<style scoped lang="scss">
.available-students-per-group,
.available-students-per-subgroup {
    .student-checkbox {
        margin-bottom: map-get($grid-gutter-spacing, 'ten');

        &:hover {
            ::v-deep .custom-control-label {
                font-weight: $font-weight-normal;

                &:hover {
                    cursor: pointer;
                    font-weight: $font-weight-bold;
                }
            }

            > ::v-deep .custom-control {
                cursor: default;
            }
        }
    }


    ::v-deep .custom-control-label {
        &:before,
        &:after {
            top: 0.05rem;
        }
    }

    &:hover {
        > ::v-deep .custom-control {
            cursor: default;
        }

        ::v-deep .custom-control-label {
            font-weight: $font-weight-normal;
        }
    }
}

.available-students-per-group {
    max-height: 450px;
    overflow-y: auto;
}

.group-name {
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
}


.available-students-per-subgroup {
    padding-left: map-get($grid-gutter-spacing, 'fifteen');
    list-style: none;

    .group-name {
        margin-top: map-get($grid-gutter-spacing, 'eight');
    }
}


@media(min-width: map-get($grid-breakpoints, 'lg')) {
    .available-students-per-group {
        max-height: 500px;
    }
}
</style>